import { DateTime } from 'luxon'

export const CONTEST_START = DateTime.utc(2026, 10, 1, 0, 0, 0, 0).setZone('America/Los_Angeles', {
  keepLocalTime: true,
})

export const CONTEST_END = DateTime.utc(2027, 1, 1, 0, 0, 0, 0)
  .setZone('America/New_York', {
    keepLocalTime: true,
  })
  .minus({ seconds: 1 })
